import { getSupabase, ensureAnonSession } from './supabase.js';

// Thin wrappers around the 5 Edge Functions. Each resolves with the
// `data` payload from `{ok:true, data}` envelopes or throws with the
// server-provided error code.

async function invoke(fnName, body) {
  await ensureAnonSession();
  const db = getSupabase();
  const { data, error } = await db.functions.invoke(fnName, { body });
  // When the function returns a 4xx/5xx, the SDK sets `error` to a generic
  // "non-2xx" FunctionsHttpError. The structured error envelope (if any)
  // is on `error.context` as a Response object — parse it for our real code.
  if (error) {
    let code = error.message || 'network_error';
    let detail;
    const ctx = error.context;
    if (ctx && typeof ctx.json === 'function') {
      try {
        const body = await ctx.json();
        if (body && body.error) {
          code = body.error;
          detail = body.detail;
        }
      } catch {
        /* not json — keep the generic message */
      }
    }
    const e = new Error(code);
    e.detail = detail;
    throw e;
  }
  if (!data || data.ok !== true) {
    const code = data?.error || 'unknown_error';
    const e = new Error(code);
    e.detail = data?.detail;
    throw e;
  }
  return data.data;
}

export function createGame(display_name) {
  return invoke('create_game', { display_name });
}

export function joinGame(code, display_name) {
  return invoke('join_game', { code, display_name });
}

export function addAi(game_id, seat) {
  return invoke('add_ai', { game_id, seat });
}

export function startGame(game_id) {
  return invoke('start_game', { game_id });
}

export function submitMove(game_id, action, payload) {
  return invoke('submit_move', { game_id, action, payload });
}

export async function loadGameRow(game_id) {
  await ensureAnonSession();
  const db = getSupabase();
  const { data, error } = await db.from('games').select('*').eq('id', game_id).maybeSingle();
  if (error) throw error;
  return data;
}

export async function loadSeats(game_id) {
  await ensureAnonSession();
  const db = getSupabase();
  const { data, error } = await db.from('seats').select('*').eq('game_id', game_id).order('seat');
  if (error) throw error;
  return data ?? [];
}
